import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Call } from 'app/models/dto/call.model';
import { LenderUser } from 'app/models/dto/lender-user.model';
import { combineLatest, Observable, Subject, takeUntil } from 'rxjs';
import { UserCallHistoryState } from '../../state/call-history/call-history.state';
import { FilterSelection, LoadMore, SortSelection, UserSpecified, CallSelection } from '../../state/call-history/call-history.action';
import {
  MarkAllMissedCallsRead
} from 'ng2-app/modules/today/state/today-badge-counts/today-badge-counts.action';
import {TodayBadgeCountsState} from 'ng2-app/modules/today/state/today-badge-counts/today-badge-counts.state';
import { UserActionItemsState } from '../../state/user-action-items.state';
import { environment } from 'environments/environment';
@Component({
  selector: 'app-user-call-history-list-view',
  templateUrl: './user-call-history-list-view.component.html',
  styleUrls: ['./user-call-history-list-view.component.scss'],
  standalone: false
})
export class UserCallHistoryListViewComponent implements OnInit, OnDestroy {

  @Select(UserActionItemsState.user) user$: Observable<LenderUser>;
  @Select(UserCallHistoryState.stateByKey('loading')) historyLoading$: Observable<boolean>;
  @Select(UserCallHistoryState.stateByKey('history')) history$: Observable<Call[]>;
  @Select(UserCallHistoryState.stateByKey('selectedCall')) selectedCall$: Observable<Call>;
  @Select(UserCallHistoryState.stateByKey('filter')) filter$: Observable<string>;
  @Select(UserCallHistoryState.stateByKey('sort')) sort$: Observable<string>;
  @Select(UserCallHistoryState.stateByKey('page')) page$: Observable<number>;
  @Select(UserCallHistoryState.stateByKey('nextPage')) nextPage$: Observable<number>;
  @Select(UserCallHistoryState.stateByKey('lastPage')) lastPage$: Observable<number>;
  @Select(UserCallHistoryState.stateByKey('total')) total$: Observable<number>;
  @Select(TodayBadgeCountsState.missedCalls) missedCallCount$: Observable<number>;

  destroyed$ = new Subject<boolean>();

  constructor( private store: Store ) {}

  ngOnInit(): void {
    combineLatest([this.user$, this.missedCallCount$])
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: ([lenderUser, missedCallCount]) => {
          this.store.dispatch( new UserSpecified(lenderUser.id));
          if(missedCallCount > 0) {
            this.store.dispatch(new MarkAllMissedCallsRead(lenderUser.id));
          }
        },
        error: (error) => {
          console.error('Error in user call history subscription:', error);
        }
      });
  }

  setFilter(newFilterSelection) {
    this.store.dispatch( new FilterSelection(newFilterSelection) );
  }

  setSort(newSortSelection) {
    this.store.dispatch( new SortSelection(newSortSelection) );
  }

  setSelection(call) {
    this.store.dispatch( new CallSelection(call) );
  }

  loadMore() {
    this.store.dispatch( new LoadMore() );
  }

  playRecording(callId: number): void {
    if (callId) {
      const url = `${environment.API_URL}/phone/recording-media/${callId}`;
      window.open(url);
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  phoneDisplay(call): string {
    return call.type === 'outgoing' ? call.toNumber : call.fromNumber;
  }
}
